export default __webpack_public_path__ + "static/media/cp_geo_bf.1a7a4f33.svg";